import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import PagePlugin from '../../components/plugins/pagePlugin/PagePlugin';

import { tabTypeMap } from '../../model/types';
import { getSelectedTabKeyFromUrl } from '../../store/childStore/tabStore';
import { useTabStore } from '../../store/RootStoreContext';

interface Props {
    isCollapsed: boolean;
}

export default observer(function PagePluginsContainer({ isCollapsed }: Props) {
    const { tabs } = useTabStore();
    const { asPath } = useRouter();
    const selectedTabKey = getSelectedTabKeyFromUrl(asPath);

    return (
        <>
            {tabs.map(
                (tab) =>
                    tab.type === tabTypeMap.PLUGIN && (
                        <PagePlugin
                            key={tab.key}
                            rootClassName={clsx('page-plugin', {
                                collapsed: !isCollapsed,
                                hidden: selectedTabKey !== tab.key
                            })}
                            pluginId={tab.key.split(`${tabTypeMap.PLUGIN}-`)[1]}
                        />
                    )
            )}
        </>
    );
});
